export default "__VITE_ASSET__Q6hWEaiE__"